<template>
    <div>
        <div v-ls-scroll="checkScroll" :class="{ affix: affixed }" :style="{ width: width }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import lsScroll from '@/directives/scroll/scroll.directive';

/**
 * Implementation from http://wffranco.github.io/vue-strap/
 */
export default {
    directives: {
        lsScroll,
    },
    props: {
        offset: {
            type: Number,
            default: 0,
        },
        minHeightDisabled: {
            // used to disabled affix at a min height, if window isn't larger than
            // this number it will never affix
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            affixed: false,
            width: null,
        };
    },
    computed: {
        top() {
            return this.offset > 0 ? `${this.offset}px` : null;
        },
    },
    methods: {
        // from https://github.com/ant-design/ant-design/blob/master/components/affix/index.jsx#L20
        checkScroll() {
            // only calculate when element is visible
            if (
                !(this.$el.offsetWidth || this.$el.offsetHeight || this.$el.getClientRects().length)
            ) {
                return;
            }
            // get window scroll and element position to detect if element should be affixed
            const scroll = {};
            const element = {};
            const rect = this.$el.getBoundingClientRect();
            const { body } = document;
            this.width = `${rect.width}px`;
            const windowHeight = window.innerHeight;

            // short circuit, only affix if windowHeight is tall enough to show full order
            if (windowHeight && this.minHeightDisabled) {
                this.affixed = windowHeight > this.minHeightDisabled;
                return;
            }

            _.forEach(['Top', 'Left'], (type) => {
                const t = _.toLower(type);
                let ret = window[`page${type === 'Top' ? 'Y' : 'X'}Offset`];
                const method = `scroll${type}`;
                if (!_.isNumber(ret)) {
                    // ie6,7,8 standard mode
                    ret = document.documentElement[method];
                    if (!_.isNumber(ret)) {
                        // quirks mode
                        ret = document.body[method];
                    }
                }
                scroll[t] = ret;
                element[t] =
                    _.add(scroll[t], rect[t]) -
                    (this.$el[`client${type}`] || body[`client${type}`] || 0);
            });

            const fix = scroll.top > element.top - this.offset;
            if (this.affixed !== fix) {
                this.affixed = fix;
            }
        },
    },
};
</script>
